/* eslint-disable react/jsx-key */
import React, { useState, memo } from "react";
import { FormattedMessage } from "react-intl";
import MoreDetails from "app/pages/.shared/MoreDetails";
import List from "app/pages/.shared/List";
import { creditCardTypesValues } from "app/utils/propTypes";
import CreditCardPictos from "app/pages/.shared/CreditCardPictos/CreditCardPictos";

import "./SecurityNote.scss";
import IconLock from "app/pages/.shared/IconLock";
import PropTypes from "prop-types";

const SecurityNote = ({ acceptedCreditCards, brandDisplayName }) => {
	const [showDetails, setShowDetails] = useState(false);

	return (
		<div className="security-note">
			<div className="security-note__header">
				<div className="security-note__title-icons">
					<div className="security-note__title">
						<IconLock />
						<FormattedMessage id="payment.security.full" />
					</div>
					<CreditCardPictos creditCardCodes={acceptedCreditCards} />
				</div>
				<div
					className="security-note__more-details"
					onClick={() => setShowDetails(!showDetails)}
				>
					<FormattedMessage
						id={showDetails ? "product.page.less.details" : "product.page.more.details"}
					/>
				</div>
			</div>

			<div className="security-note__details">
				<MoreDetails expanded={showDetails}>
					<List
						items={[
							<FormattedMessage id="payment.security.note.1" />,
							<FormattedMessage id="payment.security.note.2" />,
							<FormattedMessage
								id="payment.security.note.3"
								values={{ brandName: brandDisplayName }}
							/>,
						]}
					/>
				</MoreDetails>
			</div>
		</div>
	);
};

SecurityNote.defaultProps = {
	acceptedCreditCards: [],
};

SecurityNote.propTypes = {
	acceptedCreditCards: creditCardTypesValues,
	brandDisplayName: PropTypes.string,
};

export default memo(SecurityNote);
